import { useGetRestaurantQuery } from 'generated/rbi-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLogger } from 'state/logger';

export const useRestaurantPosConnectivityStatus = (storeId: string, pollInterval?: number) => {
  const logger = useLogger();
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);

  const { loading, data, error, refetch } = useGetRestaurantQuery({
    fetchPolicy: 'cache-and-network',
    variables: { storeId },
    skip: !storeId || !enableOrdering,
    // skip does not apply to polling calls
    // if storeId is cleared, then we set the interval to 0 which ends the polling
    pollInterval: storeId ? pollInterval : 0,
    onError: err =>
      logger.warn({ err, message: `Failed to retrieve restaurant availability - ${storeId}` })
  });

  const restaurantAvailable = data?.restaurant?.available ?? null;

  const isRestaurantPosOnline: null | boolean =
    error || !enableOrdering ? true : restaurantAvailable;

  return {
    isRestaurantPosOnline,
    loading,
    refetch
  };
};
